import { useEffect, useState, Suspense, lazy } from 'react';

import './style/app.css';
import GlobalStyle from './style/GlobalStyle';

import data from './utils/data.json';
import { useLanguage } from './context/LanguageContext';

import { Routes, Route, useLocation } from 'react-router-dom';

import Header      from './components/header/Header';
import Footer      from './components/footer/Footer';
import Modal       from './components/modal/Modal';
import PageWrapper from './components/pageWrapper/PageWrapper';

/* ------ lazy imports ------ */
const Homepage     = lazy(() => import('./components/home/homepage/Homepage'));
const Galleria     = lazy(() => import('./pages/galleria/Galleria'));
const GalleriaGrid = lazy(() => import('./pages/galleriaGrid/GalleriaGrid'));

const initLinks = (lang, gallery) => {
  const links = data?.links?.[lang];
  if (gallery) {
    const filteredLinks = links?.filter(link => link?.id !== 0 && link?.id !== 1);
    const updatedLinks = filteredLinks?.map(link => {
      if (link?.id === 4) {
        return { ...link, hasFocused: true };
      } else {
        return { ...link, hasFocused: false };
      }
    });
    return updatedLinks;
  } else {
    return links;
  }
};

const NavigationHandler = () => {

  /* ------ Context API ------ */
  const { selectedLanguage } = useLanguage();

  /* --- React Router --- */
  const location = useLocation();
  const onGallery = location.pathname.startsWith("/galleria");

  /* ------ useState() ------ */
  const [links, setLinks] = useState(() => initLinks(selectedLanguage, onGallery));
  const [showModal, setShowModal] = useState(false);
  const [isUserOnGalleria, setIsUserOnGalleria] = useState(onGallery);

  /* ------ useEffect() ------ */
  useEffect(() => {
    setLinks(() => initLinks(selectedLanguage, onGallery));
  }, [selectedLanguage, onGallery]);

  return (
    <GlobalStyle>

      <Header
        links={links} setLinks={setLinks}
        setShowModal={setShowModal}
        isUserOnGalleria={isUserOnGalleria}
        setIsUserOnGalleria={setIsUserOnGalleria}
      />

      <Suspense fallback={<div style={{ minHeight: "60vh", background: "#f8f8f8"}} />}>
        <Routes>

          <Route 
            path="/" 
            element={
              <PageWrapper>
                <Homepage
                  links={links} setLinks={setLinks}
                  setIsUserOnGalleria={setIsUserOnGalleria}
                />
              </PageWrapper>
            }
          />

          <Route 
            path="/galleria"
            element={
              <PageWrapper>
                <Galleria
                  setLinks={setLinks}
                  setIsUserOnGalleria={setIsUserOnGalleria}
                />
              </PageWrapper>
            }
          />

          <Route 
            path="/galleria/:servizioId"
            element={
              <PageWrapper>
                <GalleriaGrid
                  setLinks={setLinks}
                  setIsUserOnGalleria={setIsUserOnGalleria}
                />
              </PageWrapper>
            }
          />
          
        </Routes>
      </Suspense>

      <Footer links={links} setLinks={setLinks} />

      {showModal && (
        <Modal setShowModal={setShowModal} />
      )}

    </GlobalStyle>
  );
}

export default NavigationHandler;